import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { M_Button } from "src/M_Components";

export const QuoteTablePager = ({
  page,
  totalPages,
  totalItems,
  pageSize,
  canPrev,
  canNext,
  goPrev,
  goNext,
}) => {
  if (totalItems <= pageSize) return null;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        marginTop: "8px",
      }}
    >
      <M_Button
        none
        disable={!canPrev}
        icon={<ChevronLeft />}
        onClick={goPrev}
      />
      <span style={{ fontSize: "14px", minWidth: "48px", textAlign: "center" }}>
        {page + 1} / {totalPages}
      </span>
      <M_Button
        none
        disable={!canNext}
        icon={<ChevronRight />}
        onClick={goNext}
      />
    </div>
  );
};
